import { render, staticRenderFns } from "./ClinicNew.vue?vue&type=template&id=458095b9"
import script from "./ClinicNew.vue?vue&type=script&lang=js"
export * from "./ClinicNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports